export default "/images/vendor/flag-icon-css/flags/1x1/cw.svg?914456013336fcf29568802f4dbab5a2";